import apiClient from '../utils/apiClient';

export const carruselHoteles = async (id) => {
    try {
        const response = await apiClient.get(`/carruseles/hoteles/seccion/${id}`)
        return response?.data;
    } catch (err) {
        console.log("Hubo un error al conectar con la API: ", err)
        throw new Error(err);
    }
}

export const carruselDestinos = async (id) => {
    try {
        const response = await apiClient.get(`/carruseles/destinos/seccion/${id}`)
        return response?.data;
    } catch (err) {
        console.log("Hubo un error al conectar con la API: ", err)
        throw new Error(err);
    }
}
export const carruselActividades = async (tipo) => {
    try {
        const response = await apiClient.get(`/carruseles/actividades/seccion/${tipo}`)
        return response?.data;
    } catch (err) {
        console.log("Hubo un error al conectar con la API: ", err)
        throw new Error(err);
    }
}


// export const galeriaActividades = async (seccion) => {
//     try {
//         const response = await apiClient.get(`/carruseles/actividades/${seccion}`)
//         return response?.data;
//     } catch (err) {
//         console.log("Hubo un error al conectar con la API: ", err)
//         throw new Error(err);
//     }
// }

export const TituloCarruselDeHoteles = async () => {
    try {
        const response = await apiClient.get(`/carruseles/hoteles/titulos`)
        return response?.data;
    } catch (err) {
        console.log("Hubo un error al conectar con la API: ", err)
        throw new Error(err);
    }
}